//#region src/palette.ts
const colorEntries = Object.entries({
	gray: {
		shades: [
			"#F2F3FA",
			"#E0E2EA",
			"#CED0D9",
			"#B0B2BD",
			"#9295A1",
			"#7D808C",
			"#686B79",
			"#4B4E5E",
			"#333748",
			"#1B1F32"
		],
		halfSteps: {
			"05": "#F9F9FD",
			"85": "#242A3B",
			"10": "#151B28"
		}
	},
	primary: {
		shades: [
			"#ECE6F9",
			"#D8CCF0",
			"#C4B2E7",
			"#B098DD",
			"#9C7ED4",
			"#896AC4",
			"#7655B3",
			"#6341A3",
			"#573892",
			"#4B2F81"
		],
		halfSteps: {
			"05": "#F2EEFB",
			"25": "#B9AECB",
			"55": "#8B84AB",
			"915": "#3C3057",
			"925": "#2F2746",
			"94": "#2C1E4E",
			"95": "#281A41",
			"10": "#231B31"
		}
	},
	secondary: { shades: [
		"#F4EAF7",
		"#EAD4EF",
		"#DFBFE8",
		"#D5A9E0",
		"#C07FD0",
		"#B569C8",
		"#9A32B4",
		"#9629B1",
		"#78218E",
		"#5A196A"
	] },
	error: {
		shades: [
			"#FDE7EC",
			"#FAC4D0",
			"#F7A1B5",
			"#F37E99",
			"#F05B7D",
			"#E15172",
			"#D14666",
			"#C23C5B",
			"#A62F4C",
			"#8A213D"
		],
		halfSteps: {
			"05": "#FEF3F5",
			"85": "#581533",
			"10": "#511C1C",
			"11": "#2E0E0E"
		}
	},
	info: { shades: [
		"#E7EFFB",
		"#C6D8F6",
		"#A4C1F0",
		"#83A9EB",
		"#6192E5",
		"#5382D3",
		"#4573C2",
		"#3763B0",
		"#2B579E",
		"#1E4A8B"
	] },
	warning: { shades: [
		"#FFF3CF",
		"#FFEDB0",
		"#FFE691",
		"#FFE071",
		"#FFD952",
		"#D9B73D",
		"#B49527",
		"#8E7312",
		"#77600D",
		"#5F4C07"
	] },
	success: { shades: [
		"#E4F5F3",
		"#C2E9E6",
		"#A0DDD9",
		"#7DD0CC",
		"#5BC4BF",
		"#4EAEAB",
		"#409798",
		"#338184",
		"#2A7174",
		"#216163"
	] },
	notice: { shades: [
		"#FEECE3",
		"#FED7C4",
		"#FFC3A5",
		"#FFAE85",
		"#FF9966",
		"#E88459",
		"#D26F4B",
		"#BB5A3E",
		"#A14B32",
		"#873C26"
	] },
	saving: { shades: [
		"#E2FFF4",
		"#C1F5E2",
		"#ABEFDA",
		"#74E1C6",
		"#3CCBAC",
		"#19B094",
		"#0C8F79",
		"#0A7263",
		"#0B5A50",
		"#0A4A42"
	] }
});
const prescryptivePalette = Object.fromEntries(colorEntries.map(([name, color]) => [name, color.shades]));
const prescryptiveHalfSteps = Object.fromEntries(colorEntries.flatMap(([name, color]) => color.halfSteps ? [[name, color.halfSteps]] : []));

//#endregion
export { prescryptiveHalfSteps, prescryptivePalette };